/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryResponse,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsPathParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods401,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods500,
} from "../../types/individualPaymentLookupsController/GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods.ts";

function getGetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsUrl(
  courseFinancialId: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsPathParams["courseFinancialId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/course-financials/${courseFinancialId}/available-payment-methods` as const,
  };
  return res;
}

/**
 * @description Migrado do legado IndividualPayment/GetAvailablePaymentMethodsByCourse. **(Requer Authorization para autenticação)**
 * @summary Métodos de pagamento disponíveis no plano do curso (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/course-financials/:courseFinancialId/available-payment-methods}
 */
export async function getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods(
  courseFinancialId: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsPathParams["courseFinancialId"],
  params?: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods401
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsUrl(
      courseFinancialId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
